export default __webpack_public_path__ + "static/media/eco-cyclers.1d32a70d.jpg";